if (!customElements.get('tab-collection-swiper')) {
    class TabCollectionSwiper extends HTMLElement {
        mySwiper;
        thumbButtons;
        switchContainer;
        swiper;
        thumbTabList;
        thumbTab;
        headerWrapper;
        initialTabsOffsetTop; // 新增属性记录初始位置
        tabPlacehoder;
        pcGrid = 8; // PC端数量
        mbGrid = 8; // 移动端数量

        constructor() {
            super();
            this.initialTabsOffsetTop = null; // 初始化时为 null
            this.initElements();
        }

        initElements() {
            this.thumbButtons = this.querySelector('.tab-collection-swiper__expanded-button');
            this.switchContainer = this.querySelector('.tab-collection-swiper__tabs');
            this.collectionContainer = this.querySelector('.tab-collection-swiper__collections');
            this.swiper = this.querySelector('.tab-collection-swiper__collections .swiper');
            this.thumbTabList = this.querySelector('.tab-collection-swiper__expanded-labels');
            this.thumbTab = this.thumbTabList.querySelectorAll('.tab-collection-swiper__expaned_tab');
            this.headerWrapper = document.querySelector('header .ntheader_wrapper');
            this.tabPlacehoder = this.querySelector('.tab-collection-swiper__tabs-height');
        }

        connectedCallback() {
            this.initSwiper();
            this.initExpanded();
            this.getHeaderHeight();
            this.recordInitialTabsPosition();
            this.setPlaceholderHeight();

            this.setupButtonEvents();
            this.observerFunction();

            window.addEventListener('resize', this.initExpanded.bind(this));
            window.addEventListener('scroll', this.checkTabsSticky.bind(this));
        }

        recordInitialTabsPosition() {
            const tabs = this.switchContainer;
            if (tabs) {
                this.initialTabsOffsetTop = tabs.offsetTop;
            }
        }

        setupButtonEvents() {
            const buttons = this.querySelectorAll('.tab-collection-swiper__collections-grid-expanded');
            if (this.thumbButtons) {
                this.thumbButtons.addEventListener('click', () => this.tabExpand());
            }
            buttons.forEach(button => {
                button.addEventListener('click', () => this.expand(button));
            });
        }

        observerFunction() {
            // 设置定时器观察高度变化
            window.addEventListener('DOMContentLoaded', () => {
                const containers = this.querySelectorAll('.tab-collection-swiper__collections-container');
                containers.forEach(container => this.monitorContainerHeight(container));
            });
        }

        monitorContainerHeight(container) {
            let lastHeight = container.offsetHeight;
            let checkCount = 0;

            const intervalId = setInterval(() => {
                const currentHeight = container.offsetHeight;
                if (currentHeight !== lastHeight) {
                    lastHeight = currentHeight;
                    this.mySwiper.update(); // 更新 swiper 实例的大小
                }

                checkCount++;
                if (checkCount >= 30) { // 持续观察10秒（每2秒一次）
                    clearInterval(intervalId); // 移除观察器
                }
            }, 2000);
        }

        initSwiper() {
            this.mySwiper = new Swiper(this.swiper, {
                slidesPerView: 1,
                observer: true,
                resizeObserver: true,
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoHeight: true,
            });

            this.setupTabEvents();
        }

        setupTabEvents() {
            this.switchContainer.querySelectorAll('.tab-collection-swiper__tab').forEach((tab, index) => {
                tab.addEventListener('click', () => this.handleTabClick(tab, index));
            });

            this.thumbTab.forEach((thumb, index) => {
                thumb.addEventListener('click', () => this.handleThumbTabClick(index));
            });
        }

        handleTabClick(tab, index) {
            this.updateTabStatus(tab);
            this.updateThumbTabStatus(index);
            this.scrollToActiveAndTop(tab); // 滚动到选中的 tab
            const group = parseInt(tab.getAttribute('data-group'), 10) - 1;
            this.mySwiper.slideTo(group);
        }

        updateTabStatus(activeTab) {
            this.switchContainer.querySelectorAll('.tab-collection-swiper__tab').forEach(tab => {
                tab.setAttribute('data-status', tab === activeTab ? 'active' : 'inactive');
            });
        }

        updateThumbTabStatus(activeIndex) {
            this.thumbTab.forEach((thumb, index) => {
                thumb.setAttribute('data-status', index === activeIndex ? 'active' : 'inactive');
            });
        }

        handleThumbTabClick(index) {
            const correspondingTab = this.switchContainer.querySelector(`.tab-collection-swiper__tab[data-group="${index + 1}"]`);
            if (correspondingTab) {
                correspondingTab.click(); // 触发 tab 的点击事件
                this.hideThumbTabList();
            }
        }

        initExpanded() {
            const itemsContainer = this.querySelectorAll('.tab-collection-swiper__collections-container');
            const threshold = this.getGridThreshold();

            itemsContainer.forEach(container => {
                const layout = container.querySelector('.tab-collection-swiper__collections-grid-layout');
                const items = layout.querySelectorAll('.tab-collection-product_item');
                const status = layout.getAttribute('aria-expanded');
                const button = container.querySelector('.tab-collection-swiper__collections-grid-expanded');

                if (status === 'true') return;

                if (items.length < threshold) {
                    if (button) button.style.display = 'none'; // 隐藏按钮
                }

                this.updateItemVisibility(items, threshold);
            });
        }

        getGridThreshold() {
            const isPC = window.matchMedia("(min-width: 1001px)").matches;
            return isPC ? this.pcGrid : this.mbGrid;
        }

        updateItemVisibility(items, threshold) {
            items.forEach((item, index) => {
                item.style.display = index >= threshold ? 'none' : '';
            });
        }

        expand(button) {
            const container = button.closest('.tab-collection-swiper__collections-container');
            const targetItemsContainer = button.previousElementSibling;

            if (targetItemsContainer && targetItemsContainer.classList.contains('tab-collection-swiper__collections-grid-layout')) {
                const items = targetItemsContainer.querySelectorAll('.tab-collection-product_item');
                items.forEach(item => {
                    item.style.display = ''; // 移除 display: none
                });
                targetItemsContainer.setAttribute('aria-expanded', 'true'); // 设置 aria-expanded 为 true
                this.mySwiper.update();
            }
        }

        tabExpand() {
            const status = this.thumbButtons.getAttribute('aria-expanded');
            this.thumbTabList.style.display = status === 'false' ? '' : 'none'; // 切换显示状态
            this.thumbButtons.setAttribute('aria-expanded', status === 'false' ? 'true' : 'false');
        }

        hideThumbTabList() {
            this.thumbTabList.style.display = 'none';
            this.thumbButtons.setAttribute('aria-expanded', 'false');
        }

        scrollToActiveAndTop(tab) {
            const tabWrapper = this.switchContainer.querySelector('.tab-collection-swiper__tabs-wrapper');
            if (tabWrapper) {
                const tabRect = tab.getBoundingClientRect();
                const wrapperRect = tabWrapper.getBoundingClientRect();
                const offset = tabRect.left - wrapperRect.left + tabRect.width / 2 - wrapperRect.width / 2;

                // 滚动到选中的 tab
                tabWrapper.scrollTo({
                    left: offset,
                    behavior: 'smooth' // 平滑滚动
                });
            }

            // 计算目标 Y 坐标
            const containerRect = this.collectionContainer.getBoundingClientRect();
            const scrollY = window.scrollY;
            const headerHeight = parseFloat(getComputedStyle(this).getPropertyValue('--header-height'));
            const tabsHeight = this.switchContainer.offsetHeight;
            const targetY = scrollY + containerRect.top - headerHeight - tabsHeight;

            // 平滑滚动到目标位置
            window.scrollTo({
                top: targetY,
                behavior: 'smooth'
            });
        }

        checkTabsSticky() {
            if (!this.switchContainer || !this.headerWrapper) {
                console.warn('Tabs or header wrapper not found.');
                return false;
            }

            const headerHeight = parseFloat(getComputedStyle(this).getPropertyValue('--header-height'));
            const scrollY = window.scrollY;

            const thisBottomPosition = this.getBoundingClientRect().bottom + scrollY;
            let isSticky = (scrollY + headerHeight) > this.initialTabsOffsetTop;

            if (scrollY > thisBottomPosition) {
                // 当滚动超过 this 时，设置 isSticky 为 false
                isSticky = false;
                this.switchContainer.classList.remove('is-sticky');
            } else {
                if (isSticky) {
                    this.switchContainer.classList.add('is-sticky');
                } else {
                    this.switchContainer.classList.remove('is-sticky');
                    if (!this.executionCount) {
                        this.executionCount = 0;
                    }

                    if (this.executionCount < 10) {
                        this.recordInitialTabsPosition();
                        this.executionCount++;
                    }
                }
            }
            return isSticky;
        }

        setPlaceholderHeight() {
            const tabHeight = this.switchContainer.offsetHeight;
            this.tabPlacehoder.style.height = `${tabHeight}px`;
        }

        getHeaderHeight() {
            const header = document.querySelector('header');
            const headerWrapper = header.querySelector('.ntheader_wrapper');
            const headerHeight = headerWrapper ? headerWrapper.offsetHeight : 0;

            // 设置 this 的 CSS 变量
            this.style.setProperty('--header-height', `${headerHeight}px`);

            // 使用 ResizeObserver 观察高度变化
            const resizeObserver = new ResizeObserver(() => {
                const newHeaderHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
                this.style.setProperty('--header-height', `${newHeaderHeight}px`);
                // console.log('Header height updated:', newHeaderHeight); // 输出新的高度
            });

            if (headerWrapper) {
                resizeObserver.observe(headerWrapper); // 开始观察
            } else {
                console.warn('Header wrapper not found.');
            }
        }
    }

    customElements.define('tab-collection-swiper', TabCollectionSwiper);
}
